import axios from "axios";

export const dianaApi = axios.create({
  baseURL: "https://sli.lbca.com.br/wp-json/wp/v2/",
});
